<template>
  <hm-content title="">
    <div class="mb10 flex">
      <div>
        <el-table
          :data="ssrColumnsConfigModelList"
          stripe
          style="width: 100%"
          border
          size="small"
          @selection-change="getChecked"
          max-height="300"
        >
          <el-table-column
            type="selection"
            :selectable="selectEnable"
          ></el-table-column>
          <el-table-column
            header-align="center"
            align="center"
            prop="labelName"
            label="可选数据"
            width="180"
          >
            <template slot-scope="scope">
              {{ scope.row.labelName }}
              <span v-if="scope.row.labelType === 'label'">(文本字段)</span>
              <span v-else-if="scope.row.labelType === 'value'">(值字段)</span>
            </template>
          </el-table-column>
        </el-table>
      </div>
      <div class="flex flex-column iten-center flex-center control ">
        <div class="flex flex-column text-center">
          <el-button
            size="small"
            class="hmicon icon-youjiantou"
            @click="toRight"
            :disabled="!leftChecked.length"
          ></el-button>
          <el-button
            size="small"
            class="hmicon icon-zuojiantou"
            @click="toLeft"
            :disabled="!rightChecked1.length && !rightChecked2.length"
          ></el-button>
        </div>
      </div>
      <div class="flex">
        <el-table
          :data="textList"
          stripe
          ref="dragTable"
          style="width: 200px"
          border
          size="small"
          max-height="300"
          class="mr20"
          :cell-class-name="cellClassName"
          @selection-change="getRightChecked1"
        >
          <el-table-column type="selection"></el-table-column>
          <el-table-column
            header-align="center"
            align="center"
            prop="labelName"
            label="展示文本字段"
          >
          </el-table-column>
        </el-table>
        <el-table
          :data="valueList"
          stripe
          ref="dragTable2"
          style="width: 490px"
          border
          size="small"
          max-height="300"
          :cell-class-name="cellClassName"
          @selection-change="getRightChecked2"
        >
          <el-table-column type="selection"></el-table-column>
          <el-table-column
            header-align="center"
            align="center"
            prop="labelName"
            label="展示值字段"
            width="180"
          >
          </el-table-column>
          <el-table-column
            header-align="center"
            align="center"
            prop="labelName"
            label="值类型"
          >
            <template slot-scope="scope">
              <el-select
                v-model="scope.row.valueType"
                placeholder="类型"
                size="small"
                style="width:80px"
              >
                <el-option label="求和" value="sum"></el-option>
                <el-option label="平均值" value="avg"></el-option>
              </el-select>
            </template>
          </el-table-column>
        </el-table>
      </div>

      <div class="flex-1 text-center ml20">
        <template>
          <div class="mb20 flex item-center">
            模板名称：
            <el-input
              clearable
              v-model.trim="layoutName"
              placeholder="输入报表模板的名称"
              size="small"
              class="ipt mr10"
            ></el-input>
          </div>

          <div style="font-weight:bold;font-size:17px" class="mb10">
            选择
            <span class="primary" v-if="this.dateList.length">{{
              this.dateList[0].labelName
            }}</span>
            按时间展示类型
          </div>

          <div>
            <el-select
              size="small"
              placeholder="请选择时间类型"
              v-model="dateType"
            >
              <el-option
                :label="v.itemText"
                :value="v.itemValue"
                v-for="(v, i) in dateTypeList"
                :key="i"
              ></el-option>
            </el-select>
          </div>
        </template>

        <div class="mt10">
          <el-button class="ml0" size="small" type="primary" @click="preview"
            >预览</el-button
          >
        </div>
      </div>
    </div>
    <el-table
      v-if="tableHeader.length"
      stripe
      border
      :data="tableData"
      style="width: 100%"
      id="table"
      size="small"
    >
      <el-table-column
        header-align="center"
        align="center"
        :prop="col.columnName"
        :label="col.labelName"
        v-for="(col, index) in tableHeader"
        :key="index"
      >
        <template v-if="col.children.length">
          <el-table-column
            v-for="(v, i) in col.children"
            :key="i"
            header-align="center"
            align="center"
            :prop="v.columnName + col.columnName"
            :label="v.labelName"
          >
          </el-table-column>
        </template>
      </el-table-column>
    </el-table>
    <div class="flex flex-center mt10" v-if="tableHeader.length">
      <el-button class="ml0" size="small" type="primary" @click="save"
        >保存模板</el-button
      >
    </div>
  </hm-content>
</template>

<script>
import Sortable from "sortablejs";
export default {
  data() {
    return {
      layoutName: "",
      dateTypeList: [],
      dateType: "",
      leftChecked: [],
      rightChecked1: [],
      rightChecked2: [],
      textList: [],
      valueList: [],
      dateList: [],
      list: [],
      total: 0,
      currentPage: 1,
      pageSize: 10,
      searchCondition: {},
      tableData: [
        // {
        //   provinces: "湖北",
        //   citys: "武汉",
        //   gdpone: "1000",
        //   populationone: "1000",
        //   gdptwo: "1000",
        //   populationtwo: "1000"
        // }
      ],
      tableHeader: [
        // {
        //   labelName: "省份",
        //   columnName: "provinces",
        //   children: []
        // },
        // {
        //   labelName: "城市",
        //   columnName: "citys",
        //   children: []
        // },
        // {
        //   labelName: "1月",
        //   columnName: "one",
        //   children: [
        //     {
        //       labelName: "GDP",
        //       columnName: "gdp"
        //     },
        //     {
        //       labelName: "人口",
        //       columnName: "population"
        //     }
        //   ]
        // },
        // {
        //   labelName: "2月",
        //   columnName: "two",
        //   children: [
        //     {
        //       labelName: "GDP",
        //       columnName: "gdp"
        //     },
        //     {
        //       labelName: "人口",
        //       columnName: "population"
        //     }
        //   ]
        // }
      ],
      ssrColumnsConfigModelList: [],
      id: "",
      showDate: true,
      details: {}
    };
  },
  created() {
    this.queryComponentDataType();
  },
  mounted() {
    this.id = this.$route.query.id;

    if (this.$route.query.row) {
      this.details = JSON.parse(this.$route.query.row);
    } else {
      this.details = null;
    }
    console.log("this.details: ", this.details);
    if (this.details) {
      const { layoutComponents, layoutName } = this.details;
      this.layoutName = layoutName;
      let info = JSON.parse(layoutComponents);
      for (let key in info) {
        this[key] = info[key];
      }
    } else {
      this.queryById();
    }

    // const { ssrColumnsConfigModelList } = JSON.parse(this.$route.query.row);
    // this.ssrColumnsConfigModelList = ssrColumnsConfigModelList;

    this.rowDrop();
  },
  watch: {},
  methods: {
    async save() {
      if (!this.layoutName) {
        this.$message({
          message: "请输入模板名称",
          type: "warning"
        });
        return;
      }
      let layoutComponents = {
        textList: this.textList,
        valueList: this.valueList,
        dateList: this.dateList,
        dateType: this.dateType
      };
      let params = {
        configId: this.id,
        layoutType: "ssrTemplate",
        layoutName: this.layoutName,
        layoutComponents: JSON.stringify(layoutComponents)
      };
      if (this.details) {
        params.id = this.details.id;
      }
      await this.$store.dispatch("saveStoreVisualize", params);
      this.$message({
        type: "success",
        message: "操作成功！"
      });
      this.$router.back(-1);
    },
    selectEnable(row) {
      if (row.mdComponentInfo) {
        return true;
      } else {
        return false;
      }
    },
    async queryComponentDataType() {
      const { result } = await this.$store.dispatch("queryComponentDataType");

      this.dateTypeList = result;
      if (this.details) {
        this.preview();
      }
    },
    async queryById() {
      const { result } = await this.$store.dispatch("ssrBasicConfigQueryById", {
        id: this.id
      });
      const { ssrColumnsConfigModelList } = result;
      let list = [];
      ssrColumnsConfigModelList.forEach(v => {
        if (v.mdComponentInfo) {
          Object.assign(v, v.mdComponentInfo);
        }
        if (v.labelType === "value") {
          v.valueType = "sum";
        }
        if (v.labelType === "date") {
          this.dateList.push(v);
        } else {
          list.push(v);
        }
      });

      console.log("this.dateList: ", this.dateList);

      this.ssrColumnsConfigModelList = list;
    },
    preview() {
      // if(this.textList.length&&this.valueList.length){

      // }
      if (!this.dateType) {
        this.$message({
          message: "请选择时间类型",
          type: "warning"
        });
        return;
      }
      let headerList = [];
      this.textList.forEach(v => {
        v.children = [];
      });
      // headerList = JSON.parse(JSON.stringify(this.textList));
      this.valueList.forEach(v => {
        v.children = [];
      });
      headerList.push(...this.textList);

      if (this.showDate) {
        let name = this.dateTypeList.find(v => v.itemValue === this.dateType);
        headerList.push({
          labelName: name.itemText,
          columnName: this.dateType,
          children: this.valueList
        });
      } else {
        headerList.push(...this.valueList);
      }

      this.tableHeader = headerList;
    },
    cellClassName({ columnIndex }) {
      if (columnIndex === 1) {
        return "move"; // class名称
      }
    },
    rowDrop() {
      const tbody = this.$refs.dragTable.$el.querySelectorAll(
        ".el-table__body-wrapper > table > tbody"
      )[0];
      const tbody2 = this.$refs.dragTable2.$el.querySelectorAll(
        ".el-table__body-wrapper > table > tbody"
      )[0];
      const _this = this;

      Sortable.create(tbody, {
        onEnd({ newIndex, oldIndex }) {
          const currRow = _this.textList.splice(oldIndex, 1)[0];
          _this.textList.splice(newIndex, 0, currRow);
          let list = JSON.parse(JSON.stringify(_this.textList));
          _this.textList = [];
          setTimeout(() => {
            _this.textList = list;
          }, 0);

          // _this.textList.map((v, i) => {
          //   _this.$set(_this.textList, _this.textList[i], v);
          // });
          // _this.$forceUpdate();
        }
      });

      Sortable.create(tbody2, {
        onEnd({ newIndex, oldIndex }) {
          const currRow = _this.valueList.splice(oldIndex, 1)[0];
          _this.valueList.splice(newIndex, 0, currRow);
          let list = JSON.parse(JSON.stringify(_this.valueList));
          _this.valueList = [];
          setTimeout(() => {
            _this.valueList = list;
          }, 0);
        }
      });
    },
    getRightChecked1(selection) {
      this.rightChecked1 = selection;
    },
    getRightChecked2(selection) {
      this.rightChecked2 = selection;
    },
    toLeft() {
      let rightChecked = this.rightChecked1.concat(this.rightChecked2);
      this.ssrColumnsConfigModelList.push(...rightChecked);
      this.rightChecked1.forEach(v => {
        this.textList.forEach((item, index) => {
          if (v.id === item.id) {
            this.textList.splice(index, 1);
          }
        });
      });
      this.rightChecked2.forEach(v => {
        this.valueList.forEach((item, index) => {
          if (v.id === item.id) {
            this.valueList.splice(index, 1);
          }
        });
      });

      this.rightChecked1 = [];
      this.rightChecked2 = [];
    },
    toRight() {
      // 移动选中到右边
      this.leftChecked.forEach(v => {
        if (v.labelType === "label") {
          this.textList.push(v);
        } else if (v.labelType === "value") {
          this.valueList.push(v);
        }
      });

      this.leftChecked.forEach(v => {
        this.ssrColumnsConfigModelList.forEach((item, index) => {
          if (v.id === item.id) {
            this.ssrColumnsConfigModelList.splice(index, 1);
          }
        });
      });
      this.leftChecked = [];
    },
    checkCommon(checkedData, data) {
      let result = false;
      checkedData.forEach(v => {
        data.forEach(item => {
          if (String(v.id) === String(item.id)) {
            this.$message({
              message: "请不要移动重复项",
              type: "warning"
            });
            result = true;
          }
        });
      });
      return result;
    },
    getChecked(selection) {
      this.leftChecked = selection;
    },
    async queryList() {
      const params = {
        pageSize: this.pageSize,
        pageNo: this.currentPage
      };
      const searchCondition = JSON.parse(JSON.stringify(this.searchCondition));
      Object.assign(params, searchCondition);
      const { code, result } = await this.store.dispatch("", params);
      if (code === "0") {
        const { total, records } = result;
        this.list = records;
        this.total = total;
      }
    },
    paging(page) {
      this.currentPage = page;
      this.queryList();
    },
    handleSizeChange(size) {
      this.currentPage = 1;
      this.pageSize = size;
      this.queryList();
    }
  }
};
</script>

<style scoped lang="scss">
.control {
  width: 130px;
  margin: 0 2rem;
  .el-button {
    margin: 0.5rem;
  }
}
</style>
